import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import InterviewPage from './pages/InterviewPage';
import DashboardLayout from './components/DashboardLayout';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Interview routes (for candidates) */}
        <Route path="/interview/:token" element={<InterviewPage />} />
        <Route path="/interview" element={<InterviewPage />} />

        {/* Dashboard routes (for HR) */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard/jobs" replace />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/:jobId" element={<JobDetailPage />} />
        </Route>

        {/* Default route */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
